import {Race} from "./Race";
import moment from "moment";
import {FutureRacesTab} from "./FutureRacesTab";

export const ActiveRaces = (props) => {
    const racesNames = [...new Set(props.races.sort((race1, race2) => race1.id - race2.id).map(race => race.code))]
    const isFutureRace = props.races && props.races[0] && moment(props.races[0].start).isAfter(moment())
    let races = [...props.races]
        return (
            <main className={props.inactive ? 'main-inactive' : ''}>

                {
                    !isFutureRace ? racesNames.map((name, index) => {
                        const sameCode = races.filter(race => race.code === name)
                        races = races.filter(race => race.code !== name)
                        return (<Race key={index} type={sameCode.length > 1 ? 'double' : 'single'} races={sameCode}/>)
                    })
                        :
                        <FutureRacesTab races={props.races}/>
                }
            </main>
        )
}